module.exports = __webpack_public_path__ + "img/1331780168.414c9f22.jpg";